import React from "react";
import Offer from "../components/offer/offer";

export default function OfferRouter() {
  return <Offer />;
}
